<div class="nav" [ngClass]="scrolled == true ? 'nav-white' : 'nav-blue'">
  <div class="box-transparent" [routerLink]="['/main']" aria-label="Ir a inicio"></div>
  <div class="entity-logo" *ngIf="!showDirectAreas" [ngClass]="getEntityClass()"></div>
  <div class="entity-logo-bar" [ngClass]="scrolled == true ? getEntityClassNav() : null" ></div>
  <div class="full-width">
      <ul>
          <!-- .nav-item son las entradas que en movil se recogen en el menu del burger; el
               usuario se queda siempre visible en la barra. -->
          <li class="nav-item"><a [routerLink]="['/expedientes']" routerLinkActive="router-link-active">Mis expedientes</a></li>
          <li class="nav-item" *ngIf="hasLegalAssistanceProduct"><a [routerLink]="['/queries']" routerLinkActive="router-link-active">Mis consultas</a></li>
          <li class="nav-item" *ngIf="showDirectAreas"><a [routerLink]="['/insurances']" routerLinkActive="router-link-active">Mis seguros</a></li>
          <li class="nav-item" *ngIf="showBenefits"><a [routerLink]="['/benefits']" routerLinkActive="router-link-active">Mis beneficios</a></li>

          <li class="nav-item">
              <a class="mail" aria-label="notificaciones" [routerLink]="['/notifications']" [ngClass]=" checkPendingNotifications() ?'mail-sms' : ''"></a>
          </li>
          <li>
              <a class="user" aria-label="Menu usuario" [class.open]="userMenuOpen" (click)="toggleUserMenu($event)">
                  <div class="user-menu" (click)="$event.stopPropagation()">
                      <div class="user-menu-header">
                          <h2>{{ userFullName || 'Mi cuenta' }}</h2>
                      </div>
                      <div class="user-menu-body">

                          <section class="user-menu-section">
                              <h3>MI CUENTA</h3>
                              <a class="menu-item" (click)="closeUserMenu()" [routerLink]="['/profile']" [queryParams]="{section: 'profile'}">
                                  <span class="mi-icon">
                                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                                          <circle cx="12" cy="8" r="4" stroke-linejoin="round"/>
                                          <path d="M4 21c0-4 4-7 8-7s8 3 8 7" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                  </span>
                                  <span class="mi-label">Ver/Editar perfil</span>
                                  <span class="mi-chevron">&#x203A;</span>
                              </a>
                              <a class="menu-item" (click)="closeUserMenu()" [routerLink]="['/profile']" [queryParams]="{section: 'change-password'}">
                                  <span class="mi-icon">
                                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                                          <rect x="5" y="11" width="14" height="10" rx="2"/>
                                          <path d="M8 11V8a4 4 0 0 1 8 0v3" stroke-linecap="round"/>
                                      </svg>
                                  </span>
                                  <span class="mi-label">Cambiar contraseña</span>
                                  <span class="mi-chevron">&#x203A;</span>
                              </a>
                              <a class="menu-item" *ngIf="showChangeEntity" (click)="closeUserMenu()" [routerLink]="['/entities']">
                                  <span class="mi-icon">
                                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                                          <path d="M4 7h12l-3-3M20 17H8l3 3" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                  </span>
                                  <span class="mi-label">Cambiar aseguradora</span>
                                  <span class="mi-chevron">&#x203A;</span>
                              </a>
                          </section>

                          <section class="user-menu-section" *ngIf="showDirectAreas">
                              <h3>GESTIONES</h3>
                              <a class="menu-item" (click)="closeUserMenu()" [routerLink]="['/profile']" [queryParams]="{section: 'receipts'}">
                                  <span class="mi-icon">
                                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                                          <rect x="3" y="6" width="18" height="12" rx="2"/>
                                          <circle cx="12" cy="12" r="2"/>
                                      </svg>
                                  </span>
                                  <span class="mi-label">Mis recibos</span>
                                  <span class="mi-chevron">&#x203A;</span>
                              </a>
                              <a class="menu-item" *ngIf="hasLegalAssistanceProduct" (click)="closeUserMenu()" [routerLink]="['/profile']" [queryParams]="{section: 'insured'}">
                                  <span class="mi-icon">
                                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                                          <circle cx="12" cy="8" r="4"/>
                                          <path d="M4 21c0-4 4-7 8-7s8 3 8 7" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                  </span>
                                  <span class="mi-label">Mis asegurados</span>
                                  <span class="mi-chevron">&#x203A;</span>
                              </a>
                          </section>

                          <section class="user-menu-section" *ngIf="showDirectAreas">
                              <h3>PREFERENCIAS</h3>
                              <a class="menu-item" (click)="closeUserMenu()" [routerLink]="['/profile']" [queryParams]="{section: 'notifications'}">
                                  <span class="mi-icon">
                                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                                          <path d="M6 16V11a6 6 0 0 1 12 0v5l1.5 2H4.5L6 16z" stroke-linecap="round" stroke-linejoin="round"/>
                                          <path d="M10 20a2 2 0 0 0 4 0" stroke-linecap="round"/>
                                      </svg>
                                  </span>
                                  <span class="mi-label">Notificaciones</span>
                                  <span class="mi-chevron">&#x203A;</span>
                              </a>
                              <a class="menu-item" (click)="closeUserMenu()" [routerLink]="['/profile']" [queryParams]="{section: 'consent'}">
                                  <span class="mi-icon">
                                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                                          <rect x="3" y="5" width="18" height="14" rx="2"/>
                                          <path d="M3 7l9 6 9-6" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                  </span>
                                  <span class="mi-label">Consentimientos</span>
                                  <span class="mi-chevron">&#x203A;</span>
                              </a>
                          </section>

                          <section class="user-menu-section" *ngIf="showDirectAreas">
                              <h3>AYUDA</h3>
                              <a class="menu-item" (click)="closeUserMenu()" [routerLink]="['/profile']" [queryParams]="{section: 'help'}">
                                  <span class="mi-icon">
                                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                                          <path d="M4 12a8 8 0 0 1 16 0v3a3 3 0 0 1-3 3h-1v-6h4M4 12v3a3 3 0 0 0 3 3h1v-6H4" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                  </span>
                                  <span class="mi-label">Atención al cliente</span>
                                  <span class="mi-chevron">&#x203A;</span>
                              </a>
                          </section>

                          <a class="menu-item menu-logout" (click)="closeUserMenu()" [routerLink]="['/logout']">
                              <span class="mi-icon">
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                                      <path d="M10 17l-5-5 5-5M5 12h12M14 4h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                              </span>
                              <span class="mi-label">Cerrar sesión</span>
                          </a>

                      </div>
                  </div>
              </a>
          </li>
          
      </ul>
      
  </div>
  
  <!-- Menu de navegacion (movil): recoge unicamente las entradas de .nav-item, que no caben en
       la barra. La cuenta no esta aqui, sigue colgando del icono de usuario. Unico para area
       directa y reaseguro: las entradas llevan su propio *ngIf. -->
  <div class="responsive no-text-select">
      <ul>
          <li>
              <div class="burger" (click)="toggleBurger()" [ngClass]="{ open: burgerState }"
                   [class.has-pending]="checkPendingNotifications()">
                  <div class="burger-menu" [ngClass]="getBurgerClass()">
                      <span>&nbsp;</span>
                      <span>&nbsp;</span>
                      <span>&nbsp;</span>
                  </div>
              </div>
          </li>
          <li class="inner-menu">
              <div class="menu" [ngClass]="{ 'open': burgerState }">
                  <div class="menu-body">

                      <section class="menu-section">
                          <h3>Menú</h3>
                          <a class="menu-item" (click)="toggleBurger()" [routerLink]="['/expedientes']">
                              <span class="mi-icon">
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                                      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5z" stroke-linejoin="round"/>
                                      <path d="M14 3v5h5" stroke-linejoin="round"/>
                                      <line x1="9" y1="13" x2="15" y2="13" stroke-linecap="round"/>
                                      <line x1="9" y1="17" x2="13" y2="17" stroke-linecap="round"/>
                                  </svg>
                              </span>
                              <span class="mi-label">Mis expedientes</span>
                              <span class="mi-chevron">&#x203A;</span>
                          </a>
                          <a class="menu-item" *ngIf="hasLegalAssistanceProduct" (click)="toggleBurger()" [routerLink]="['/queries']">
                              <span class="mi-icon">
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                                      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                              </span>
                              <span class="mi-label">Mis consultas</span>
                              <span class="mi-chevron">&#x203A;</span>
                          </a>
                          <a class="menu-item" *ngIf="showDirectAreas" (click)="toggleBurger()" [routerLink]="['/insurances']">
                              <span class="mi-icon">
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                                      <path d="M12 2l8 4v6c0 5-3.5 9.3-8 10-4.5-.7-8-5-8-10V6l8-4z" stroke-linejoin="round"/>
                                  </svg>
                              </span>
                              <span class="mi-label">Mis seguros</span>
                              <span class="mi-chevron">&#x203A;</span>
                          </a>
                          <a class="menu-item" *ngIf="showBenefits" (click)="toggleBurger()" [routerLink]="['/benefits']">
                              <span class="mi-icon">
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                                      <path d="M12 2l3 7h7l-5.5 4.5L18 21l-6-4-6 4 1.5-7.5L2 9h7z" stroke-linejoin="round"/>
                                  </svg>
                              </span>
                              <span class="mi-label">Mis beneficios</span>
                              <span class="mi-chevron">&#x203A;</span>
                          </a>
                          <a class="menu-item" (click)="toggleBurger()" [routerLink]="['/notifications']" [class.has-pending]="checkPendingNotifications()">
                              <span class="mi-icon">
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                                      <path d="M6 16V11a6 6 0 0 1 12 0v5l1.5 2H4.5L6 16z" stroke-linecap="round" stroke-linejoin="round"/>
                                      <path d="M10 20a2 2 0 0 0 4 0" stroke-linecap="round"/>
                                  </svg>
                              </span>
                              <span class="mi-label">Notificaciones</span>
                              <span class="mi-chevron">&#x203A;</span>
                          </a>
                      </section>

                  </div>
              </div>
          </li>
      </ul>
  </div>

</div>
<div class="aux-box" [ngClass]="{ 'visible': scrolled }"></div>